import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setOptionGroup, clearOptionGroupsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  optiongroup: PropTypes.object,
  error: PropTypes.any,
};

class OptionGroupNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
      },
      optiongroup: {
        name: '',
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.optiongroup && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Option group saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const optiongroup = this.state.optiongroup;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = optiongroup[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const optiongroup = this.state.optiongroup;
    if (e.target.type === 'checkbox') {
      _.set(optiongroup, e.target.name, e.target.checked);
    } else {
      _.set(optiongroup, e.target.name, e.target.value);
    }
    this.setState({
      optiongroup,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    this.props.dispatch(clearOptionGroupsErrors());
    this.props.dispatch(setOptionGroup(this.state.optiongroup));
  }
  handleCancel() {
    this.props.dispatch(clearOptionGroupsErrors());
    browserHistory.push('/optiongroups?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/optiongroups?page=1');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div className="optiongroup component" style={authPage}>
        <h2>New Option Group</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={this.state.optiongroup.name || ''}
              name="name"
              onChange={this.handleChange}
              errorText={this.state.required.name}
              errorStyle={{ color: cyan500 }}
            />
          </div>
        </div>
      </div>
    );
  }
}

OptionGroupNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

OptionGroupNewPage.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    optiongroup: state.optiongroups.optiongroup,
    error: state.optiongroups.error,
  };
}

export default withRouter(connect(mapStateToProps)(OptionGroupNewPage));



// WEBPACK FOOTER //
// ./src/containers/OptionGroupNewPage.js